// extracted by mini-css-extract-plugin
export default {"section":"mission_section__u7YLc"};